import { MODIFIER_ID } from '../ids/modifier-id'
import { ModifierMap } from 'web/data/models'
import { SPEC_ID } from '../ids/spec-ids'

export const ESSENCE_MODIFIERS: ModifierMap = {

    [MODIFIER_ID.ESSENCE_VOP]: {
        id: MODIFIER_ID.ESSENCE_VOP,
        name: "Visions of Perfection R3",
        shortName: "VoP-R3",

        eligibleSpecIds: [
            SPEC_ID.PRIEST.DISC,
            SPEC_ID.PRIEST.HOLY,
            SPEC_ID.DRUID.RESTO,
            SPEC_ID.MONK.MW,
            SPEC_ID.PALADIN.HOLY,
            SPEC_ID.SHAMAN.RESTO,
        ],

        meta: {},

        game_id: 299369,
        icon_name: "spell_azerite_essence_18"
    }

}
